import styled from 'styled-components';
import {LoadingBar} from '@/components/LoadingBar';
import {Typography} from '@/components/Typography';
import {AnalysisItem, KodataCategoryGroup} from '@/map/@types';
import {useStoreHallSalesCategoy} from '@/map/api/analytics/hall-sales';
import {convertToKodataCategory} from '@/map/utils';
import {Flexbox, PaddingBox} from '@/styled-components';
import {palette} from '@/styles';
import {humanizeNumber} from '@/utils';
import {CATEGORY_ICON_MAP} from './CategoryIcons';

interface IProps {
  item: AnalysisItem;
  category: KodataCategoryGroup;
}

export const CategorySalesItem = ({item, category}: IProps) => {
  const {error, isLoading, data} = useStoreHallSalesCategoy({
    item,
    categories: [category],
  });

  if (!category) return null;

  const cat1Depth = convertToKodataCategory(category.category);
  const icon = CATEGORY_ICON_MAP[cat1Depth];

  const result = data?.[0];

  return (
    <Root>
      <PaddingBox left={16} right={16} bottom={16}>
        <Flexbox>
          <Icon>
            <img src={icon} alt="업종 아이콘" />
          </Icon>
          <div>
            <Typography variant="medium14" color={palette.gray500}>
              {category.category}
            </Typography>
            <PaddingBox top={2}>
              <Typography variant="bold18" color={palette.black}>
                {category.categoryDetail}
              </Typography>
            </PaddingBox>
          </div>
        </Flexbox>
      </PaddingBox>
      {isLoading ? (
        <LoadingBar size={24} color={palette.textSecondary} />
      ) : !!error || !result?.totalSales ? (
        <PaddingBox top={12} bottom={12}>
          <Typography
            variant="medium14"
            align="center"
            color={palette.gray400}
            as="div"
          >
            분석 지역에 선택한 업종의 홀 매출 정보가 없어요
          </Typography>
        </PaddingBox>
      ) : (
        <Row>
          <div>
            <Typography variant="medium14" color={palette.gray500}>
              총 매출
            </Typography>
            <PaddingBox top={4}>
              <Typography variant="medium16" color={palette.black}>
                {humanizeNumber(result.totalSales, true)} 원
              </Typography>
            </PaddingBox>
          </div>
          <div>
            <Typography variant="medium14" color={palette.gray500}>
              월평균 매출
            </Typography>
            <PaddingBox top={4}>
              <Typography variant="medium16" color={palette.black}>
                {humanizeNumber(result.averageSales, true)} 원
              </Typography>
            </PaddingBox>
          </div>
        </Row>
      )}
    </Root>
  );
};

const Root = styled.div`
  padding: 20px 0;
  border-radius: 16px;
  border: 1px solid ${palette.gray200};
`;

const Row = styled(Flexbox)`
  & > div:first-of-type {
    border-right: solid 1px ${palette.gray150};
  }
  & > div {
    flex-shrink: 0;
    flex-grow: 1;
    padding: 0 24px;
  }
`;

const Icon = styled.div`
  border-radius: 12px;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  background-color: ${palette.bgGray100};
  margin-right: 12px;
  padding: 4px;
  img {
    width: 40px;
    height: 40px;
  }
`;
